export default "__VITE_ASSET__30ae6388__"